import { render, staticRenderFns } from "./ProjectGroup.vue?vue&type=template&id=13fffcc4"
import script from "./ProjectGroup.vue?vue&type=script&lang=ts"
export * from "./ProjectGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13fffcc4')) {
      api.createRecord('13fffcc4', component.options)
    } else {
      api.reload('13fffcc4', component.options)
    }
    module.hot.accept("./ProjectGroup.vue?vue&type=template&id=13fffcc4", function () {
      api.rerender('13fffcc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scheduler/groupComponents/ProjectGroup.vue"
export default component.exports